import React from "react";
import "./FooterSection.css";

import notesLeft from "../../assets/leftmusic.png";
import notesRight from "../../assets/rightmusic.png";

const FooterSection = () => {
  return (
    <footer className="footerSection" id="footer">
      <img src={notesLeft} alt="music notes left" className="footerNotesLeft" />
      <img src={notesRight} alt="music notes right" className="footerNotesRight" />

      <div className="footerContent">
        <h2 className="footerTitle">Forever in our hearts</h2>

        <div className="footerDivider">
          <span className="footerDot"></span>
          <span className="footerLine"></span>
          <span className="footerDot"></span>
        </div>

        <p className="footerText">
          This tribute website celebrates the life and legacy of Abdel Halim Hafez (1929–1977),
          <br />
          one of the most beloved voices in Arab music history.
        </p>

        <p className="footerText footerTextSecond">
          Design inspired by vintage Egyptian music posters and classic cinema aesthetics
        </p>

        <p className="footerCopyright">
          © 2026 • A timeless tribute to an eternal legend
        </p>
      </div>
    </footer>
  );
};

export default FooterSection;